import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Page,
  Stack,
  Button,
  Typography,
  Divider,
} from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useState, useEffect } from "react";

import { serviceSlice } from "../../reducers/serviceReducer";

import { Header } from "../../components";
import Heading from "./Heading";
import { Footer } from "./Footer";
import { ServiceOption } from "../../components/Service/ServiceOption";
import { getServiceOptions } from "../../services";

export const EditService = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const existingServiceOptions = useSelector(
    (state) => state.service.serviceOptions
  );
  const serviceOptions = useSelector(
    (state) => state.service.newServiceOptions
  );

  let history = useHistory();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  const init = async () => {
    try {
      const data = await getServiceOptions(params?.id, params?.orgId);
      dispatch(serviceSlice.actions.setServiceOptions(data));
      setRefresh(false);
    } catch (error) {
      alert(error);
      dispatch(serviceSlice.actions.setServiceOptions([]));
    }
  };

  useEffect(() => {
    if (params?.id) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (params?.id && refresh) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  /**
   * Higher order function
   **/
  // const handleSubmit = () => {};

  return (
    <Page title="FlukeWorks">
      <Header xl name="Edit a Service" history={history} />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Heading serviceId={params?.id} orgId={params?.orgId} />
        <Divider sx={{ py: 1 }} />
        <Typography variant="h4" sx={{ py: 2 }}>
          Service Options
        </Typography>
        {existingServiceOptions &&
          existingServiceOptions.map((serviceOption) => {
            return (
              <ServiceOption
                dispatch={dispatch}
                data={serviceOption}
                serviceTypeId={params?.id}
                orgId={params?.orgId}
                serviceOptions={[...existingServiceOptions, ...serviceOptions]}
                setRefresh={setRefresh}
              />
            );
          })}
        {Array.from(serviceOptions).map((serviceOption) => {
          return (
            <ServiceOption
              dispatch={dispatch}
              serviceTypeId={params?.id}
              orgId={params?.orgId}
              serviceOptions={[...existingServiceOptions, ...serviceOptions]}
              setRefresh={setRefresh}
            />
          );
        })}
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="flex-start"
          spacing={{ xs: 1, md: 2 }}
          sx={{ py: 2 }}
        >
          <div>
            <Button
              color="primary"
              // disabled={!(service.name !== "" && service.category)}
              fullWidth
              size="large"
              onClick={() => dispatch(serviceSlice.actions.addServiceOption())}
              //   type="submit"
              variant="contained"
            >
              Add Service Option
            </Button>
          </div>
        </Stack>
        <Footer history={history} dispatch={dispatch} setRefresh={setRefresh} />
      </Container>
    </Page>
  );
};
